//Get Case List
import { notification } from "antd";
import moment from "moment";
import { get, post } from "../Utils/httpInterceptor";

// const endOfMonth = moment().endOf("month").format("YYYY-MM-DD");
const currentDate = moment().format("YYYY-MM-DD");
const startOfMonth = moment().startOf("month").format("YYYY-MM-DD");
let tomorrowDate = moment().add(1, "days").format("YYYY-MM-DD");
let firtsOfNextMonth = moment()
  .add(1, "M")
  ?.startOf("month")
  .format("YYYY-MM-DD");


export const getDetails = async (data) => {
  const response = await post(`/lendermgm/support/getDetails`,data);
  if (!response.data.error) {
    notification.success({ message: response.data.message });
    return response.data;
  } else {
    notification.error({ message: response.data.message });
    return response?.data;
  }
};

export const saveDetails = async (data) => {
  const response = await post(`/lendermgm/support/saveDetails`, data);
  if (!response.data.error) {
    notification.success({ message: response.data.message });
    return response.data;
  } else {
    notification.error({ message: response.data.message });
    return response;
  }
};export const getUserBranchAllocationFlag = async (data) => {
  const response = await post(
    `/lendermgm/mapping/getUserBranchAllocationFlag`,
    data
  );
  if (!response.data.error) {
    notification.success({ message: response.data.message });
    return response.data;
  } else {
    notification.error({ message: response.data.message });
    return response?.data;
  }
};

export const uploadDocument = async (objBody = {}) => {
  const zipFiles = require("jszip")();
  zipFiles.file(objBody.file.name, objBody.file);
  const content = await zipFiles.generateAsync({ type: "blob" });
  content.name = `${new Date().getTime()}.zip`;

  const response = await post(
    "/lendermgm/support/uploadFile",
    { file: content, ...objBody.data },
    true
  );
  if (!response.data.error) {
    notification.success({ message: response.data.message });
    return response;
  } else {
    notification.error({ message: response.data.message });
    return response;
  }
};
